// extracted by mini-css-extract-plugin
module.exports = {"container":"Post_container__2tC4T","content":"Post_content__ILraH","post_does_not_exist":"Post_post_does_not_exist__1Hkfy","panel":"Post_panel__3uYqf"};